<template>
    <div>
        <div class="lead mb-3">
            {{ t.rewards_points.available_points }}: <span class="fw-bold">{{ numberFormat(customer.rewards_points) }} {{ t.rewards_points.points }}</span>
        </div>
        <div class="row">
            <div class="col-md-8 mb-4 mb-md-0">
                <h5 class="mb-3">{{ t.rewards_points.available_vouchers }}</h5>
                <div v-if="availableVouchers.length">
                    <div v-for="voucher in availableVouchers" :key="voucher.id" class="mb-3 text-md-left">
                        <div class="row border py-2 align-items-center">
                            <div class="col-md-6">
                                <div class="lead">{{ voucher.label }}</div>
                                <div class="text-muted mt-2" v-if="voucher.date_start">{{ t.vouchers.date_start}}: <b>{{ voucher.formattedDateStart }}</b></div>
                                <div class="text-muted mt-2" v-if="voucher.date_end">{{ t.vouchers.date_end}}: <b>{{ voucher.formattedDateEnd }}</b></div>
                                <div class="text-muted mt-2" v-if="voucher.products.length">
                                    <b>{{ t.vouchers.available_for_product}}:</b> <div class="ms-2" v-for="product in voucher.products" :key="product.id">{{product.name}}</div>
                                </div>
                            </div>
                            <div class="col-md lead fw-bold my-2 my-md-0">
                                {{ numberFormat(voucher.rewards_points) }} {{ t.rewards_points.points }}
                            </div>
                            <div class="col-md">
                                <div class="btn btn-primary w-100" @click="collect(voucher)">
                                    {{ t.rewards_points.collect }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    {{ t.rewards_points.no_vouchers_available }}
                </div>
            </div>
            <div class="col-md">
                <h5 class="mb-3">{{ t.rewards_points.your_vouchers }}</h5>
                <div v-if="customer.vouchers.length">
                    <div v-for="voucher in customer.vouchers" :key="voucher.id" class="border border-dashed border-2px p-3 text-center mb-3">
                        <div class="lead">{{ t.vouchers.code}}: <span class="fw-bold">{{voucher.code}}</span></div>
                        <div class="lead">{{ voucher.label }}</div>
                        <div class="text-muted mt-2" v-if="voucher.date_start">{{ t.vouchers.date_start}}: <b>{{ voucher.formattedDateStart }}</b></div>
                        <div class="text-muted mt-2" v-if="voucher.date_end">{{ t.vouchers.date_end}}: <b>{{ voucher.formattedDateEnd }}</b></div>
                        <div class="text-muted mt-2" v-if="voucher.products.length">
                            <b>{{ t.vouchers.available_for_product}}:</b> <div class="ms-2" v-for="product in voucher.products" :key="product.id">{{product.name}}</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    {{ t.rewards_points.no_vouchers_available }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            config: config,
            t: t,
            customer: customer,
            availableVouchers: available_vouchers,
        };
    },
    methods: {
        collect(voucher) {
            if (!this.config.modules.demo_mode) {
                axios
                    .post("/ajax/rewards-points/collect", {
                        voucher_id: voucher.id,
                    })
                    .catch((error) => {
                        Vue.notify({ text: error.message, type: "error" });
                    })
                    .then((response) => {
                        Vue.notify({
                            type: response.data.type, // error / success
                            text: response.data.msg,
                            duration: 7000
                        });
                        if (response.data.type == 'success') {
                            this.customer = response.data.customer
                            this.availableVouchers = response.data.available_vouchers
                        }
                    });
            }
        },
    },
};
</script>
